document.addEventListener('DOMContentLoaded', () => {
  const bindToggle = (buttonSelector, targetId) => {
    const button = document.querySelector(buttonSelector);
    const target = document.getElementById(targetId);
    if (!button || !target) return;
    button.addEventListener('click', () => {
      const open = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!open));
      target.hidden = open;
      target.classList.toggle('is-open', !open);
      if (!open) target.querySelector('input')?.focus();
    });
  };
  bindToggle('.search-toggle', 'HeaderSearch');
  bindToggle('.menu-toggle', 'PremiumNavigation');
});
